import { useEffect } from 'react';
import type { UseFormSetValue } from 'react-hook-form';
import type { ProductFeeFormInput } from '../schemas/productFee.schema';
import type { FeeReferenceData } from '../services/productFees';

interface Params {
    selectedValueType?: FeeReferenceData['fee_value_types'][number];
    isPercentageType: boolean;
    requiresLookup: boolean;
    setValue: UseFormSetValue<ProductFeeFormInput>;
}

/**
 * Clears the fields the opposite value-type mode hides, so a value-type switch never
 * leaves a stale net/gross or percentage in form state that the (now hidden) input
 * cannot reach — which would otherwise fail the coherence refinement on submit. Guarded
 * on a resolved value type so the async reference-data load does not transiently wipe
 * an edit row's stored value.
 */
export function useProductFeeDerivation({
    selectedValueType, isPercentageType, requiresLookup, setValue,
}: Params) {
    useEffect(() => {
        if (!selectedValueType) {
            return;
        }
        if (isPercentageType) {
            setValue('default_cost_net', null);
            setValue('default_cost_gross', null);
        } else {
            setValue('default_percentage', null);
            setValue('cap_value_gross', null);
        }
        if (!requiresLookup) {
            setValue('bands', undefined);
        }
    }, [isPercentageType, requiresLookup, selectedValueType, setValue]);
}
